// extracted by mini-css-extract-plugin
export default {"menuSection":"MenuSection_menuSection__7LZLs","sectionHeading":"MenuSection_sectionHeading__dl+sn"};